<span class="loader"
[style.--width1]=" width+ 'px'"
[style.--width2]=" (width * 0.2439)+ 'px'"
[style.--width3]="(width * 0.1219)+ 'px'"
[style.--thickness]=" thickness+ 'px'"
[style.--primaryColor]="primaryColor "
[style.--secondaryColor]="secondaryColor "></span>